import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/Login.vue'
import Transaction from '../views/Transaction.vue'
import Create from '../views/Create.vue'
import Edit from '../views/Edit.vue'
import Loan from '../views/Loan.vue'
import Salary from '../views/Salary.vue'
import CreateSalary from '../views/CreateSalary.vue'
import UpahPasang from '../views/UpahPasang.vue'
import store from '../store/index'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Transaction
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/create',
    name: 'Create',
    component: Create
  },
  {
    path: '/edit/:id',
    name: 'Edit',
    component: Edit
  },
  {
    path: '/loan',
    name: 'Loan',
    component: Loan
  },
  {
    path: '/salary',
    name: 'Salary',
    component: Salary
  },
  {
    path: '/create-salary',
    name: 'CreateSalary',
    component: CreateSalary
  },
  {
    path: '/job-sheet',
    name: 'JobSheet',
    component: () => import('../views/JobSheet.vue')
  },
  {
    path: '/create-job-sheet',
    name: 'CreateJobSheet',
    component: () => import('../views/CreateJobSheet.vue')
  },
  {
    path: '/create-job-sheet-individual',
    name: 'CreateJobSheetIndividual',
    component: () => import('../views/CreateJobSheetIndividual.vue')
  },
  {
    path: '/edit-job-sheet/:id',
    name: 'EditJobSheet',
    component: () => import('../views/EditJobSheet.vue')
  },
  {
    path: '/edit-job-sheet-individual/:id',
    name: 'EditJobSheetIndividual',
    component: () => import('../views/EditJobSheetIndividual.vue')
  },
  {
    path: '/print-job-sheet/:id',
    name: 'PrintJobSheet',
    component: () => import('../views/PrintJobSheet.vue')
  },
  {
    path: '/print-kartu/:id',
    name: 'PrintKartuJobSheet',
    component: () => import('../views/PrintKartuJobSheet.vue')
  },
  {
    path: '/upah-pasang',
    name: 'UpahPasang',
    component: UpahPasang
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login') {
    const user = store.state.user
    const allowedLevels = ['1', '3', 1, 3]
    if (
      store.state.token !== null &&
      user &&
      allowedLevels.includes(user.level)
    ) {
      next()
    } else {
      // Clear session if user doesn't have access
      localStorage.removeItem('X-FPRINT-TOKEN')
      localStorage.removeItem('X-FPRINT-USER')
      store.dispatch('set_token', null)
      store.dispatch('set_user', null)
      next({ name: 'Login' })
    }
  } else {
    if (store.state.token !== null) {
      next({ name: 'Home' })
    } else {
      next()
    }
  }
})

export default router
